var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { column: "" } },
    [
      _c(
        "v-layout",
        { attrs: { column: "" } },
        [
          _c(
            "v-toolbar",
            {
              staticClass: "load-toolbar",
              attrs: {
                extended: "",
                dense: "",
                "extension-height": "100",
                flat: ""
              }
            },
            [
              _c(
                "v-btn-toggle",
                {
                  attrs: { mandatory: "" },
                  model: {
                    value: _vm.viewToggle,
                    callback: function($$v) {
                      _vm.viewToggle = $$v
                    },
                    expression: "viewToggle"
                  }
                },
                [
                  _c(
                    "v-btn",
                    { attrs: { value: "text" } },
                    [
                      _c("span", [_vm._v("Text Message")]),
                      _vm._v(" "),
                      _c("v-icon", [_vm._v("textsms")])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    { attrs: { value: "file" } },
                    [
                      _c("span", [_vm._v("Upload File")]),
                      _vm._v(" "),
                      _c("v-icon", [_vm._v("attach_file")])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-toolbar-items",
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { flat: "" },
                      on: { click: _vm.reloadConversation }
                    },
                    [
                      _c(
                        "v-layout",
                        { attrs: { column: "" } },
                        [
                          _c("v-icon", [_vm._v("refresh")]),
                          _vm._v("\n            Reload\n          ")
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "template",
                { slot: "extension" },
                [
                  _vm.viewToggle === "text"
                    ? [
                        _c(
                          "v-flex",
                          { attrs: { sm10: "", xs8: "" } },
                          [
                            _c("v-textarea", {
                              attrs: {
                                block: "",
                                rows: 2,
                                label: "Type something..."
                              },
                              model: {
                                value: _vm.messageText,
                                callback: function($$v) {
                                  _vm.messageText = $$v
                                },
                                expression: "messageText"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("v-spacer"),
                        _vm._v(" "),
                        _c(
                          "v-flex",
                          { attrs: { sm2: "", xs4: "" } },
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "mr-0 px-0",
                                attrs: {
                                  block: "",
                                  loading: _vm.loadingData,
                                  disabled: _vm.loadingData
                                },
                                on: { click: _vm.sendMessage }
                              },
                              [_vm._v("\n              Send\n            ")]
                            )
                          ],
                          1
                        )
                      ]
                    : [
                        _c(
                          "v-flex",
                          { attrs: { sm9: "", xs8: "" } },
                          [
                            _c("v-textarea", {
                              attrs: {
                                block: "",
                                rows: 2,
                                label: "Type something then select image..."
                              },
                              model: {
                                value: _vm.messageText,
                                callback: function($$v) {
                                  _vm.messageText = $$v
                                },
                                expression: "messageText"
                              }
                            }),
                            _vm._v(" "),
                            _c("input", {
                              ref: "settlementAttach_" + _vm.itemId,
                              attrs: { type: "file", hidden: "" },
                              on: {
                                change: function($event) {
                                  return _vm.processSettlementAttachment($event)
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("v-spacer"),
                        _vm._v(" "),
                        _c(
                          "v-flex",
                          { attrs: { sm3: "", xs4: "" } },
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "primary ml-0",
                                attrs: {
                                  loading: _vm.loadingData,
                                  disabled:
                                    _vm._.isEmpty(_vm.messageText) ||
                                    _vm.loadingData
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.openFileSelector(
                                      "settlementAttach_" + _vm.itemId
                                    )
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n              Select File\n            "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]
                ],
                2
              )
            ],
            2
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm._t("conversationBanner"),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "timeline-section mt-2",
          class: [
            {
              "text-md-center text-lg-center text-sm-center pt-4":
                _vm.loadingData
            }
          ],
          staticStyle: { height: "380px" }
        },
        [
          _vm.timeline && !_vm.loadingData
            ? _c("timeline", { attrs: { "timeline-object": _vm.timeline } })
            : _vm._e(),
          _vm._v(" "),
          _vm.loadingData
            ? _c("v-progress-circular", {
                attrs: { indeterminate: "", color: "primary" }
              })
            : _vm._e()
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e7212f8e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e7212f8e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LoadConversation.vue
// module id = null
// module chunks = 